import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import http from '@/api'
import 'babel-polyfill'
import './style.scss'
Vue.use(ElementUI)

Vue.prototype.$http = http
Vue.config.productionTip = false
Vue.prototype.httpurl = 'https://jjxymss.scujj.edu.cn/'
let vue = new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})

Vue.use(vue)



// WEBPACK FOOTER //
// ./src/main.js